<template>
  <v-container fluid class="pa-8">
    <v-row align="center" justify="center">
      <v-col cols="12" class="mb-2">
        <home-current-page>
        </home-current-page>
      </v-col>
      <v-col cols="12">
        <h2 class="title-page">Dados das estações</h2>
        <h4 class="mt-2 subtitle-page">Use o formulário para consultar os dados das estações.</h4>
      </v-col>
      <v-col cols="12">
        <v-tabs v-model="tab" color="secondary lighten-1" background-color="transparent" :class="this.$vuetify.breakpoint.name === 'xs' ? 'ml-n12' : ''">
          <v-tab class="white--text" active-class="secondary--text text--lighten-1" style="font-weight: normal;font-size: 16px;line-height: 20px;">
            Dados sumários
          </v-tab>
          <v-tab class="white--text" active-class="secondary--text text--lighten-1" style="font-weight: normal;font-size: 16px;line-height: 20px;">
            Dados observados
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item class="primary darken-2 elevation-0" >
            <summaries-data
              v-if="tab === 0"
              :stations="processedListStations"
              :searchResult="resultOfStationData"
              :loadingOtherPeriod="loadingOtherPeriod"
              :loadingData="loadingData"
              @changeDataType="changeDataType($event)"
              @searchStationData="searchData($event)"
              @applyPeriod="applyPeriod($event)"
            >
            </summaries-data>
          </v-tab-item>
          <v-tab-item class="primary darken-2 elevation-0" >
            <observed-data
              v-if="tab === 1"
              :stations="processedListStations"
              :searchResult="resultOfStationData"
              :loadingOtherPeriod="loadingOtherPeriod"
              :loadingData="loadingData"
              @changeDataType="changeDataType($event)"
              @searchStationData="searchData($event)"
              @applyPeriod="applyPeriod($event)"
            >
            </observed-data>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import HomeCurrentPage from "../../components/common/HomeCurrentPage.vue";
import ObservedData from '../../components/stations-data/ObservedData.vue';
import SummariesData from '../../components/stations-data/SummariesData.vue';
export default {
  components: {
    HomeCurrentPage,
    SummariesData,
    ObservedData,
  },
  data:()=>({
    tab: 0,
    processedListStations: [],
    resultOfStationData: undefined,
    loadingOtherPeriod: false,
    loadingData: false,
  }),
  watch:{
    tab(){
      this.resultOfStationData = undefined;
    }
  },
  computed:{
    stations (){
      return this.$store.getters.stations
    },
    sensors(){
      return this.$store.getters.sensors
    },
    sensorStations(){
      return this.$store.getters.sensorStations
    },
    operations(){
      return this.$store.getters.operations
    },
    operationSensorStations(){
      return this.$store.getters.operationSensorStations
    },
    hourlySummary(){
      return this.$store.getters.hourlySummary
    },
    dailySummary(){
      return this.$store.getters.dailySummary
    },
    monthlySummary(){
      return this.$store.getters.monthlySummary
    },
    qualities(){
      return this.$store.getters.qualities
    },
    readignsData(){
      return this.$store.getters.readignsData
    },
    organizations(){
      return this.$store.getters.organizations;
    }
  },
  methods:{
    async initialize(summary_operation){
      await this.$store.dispatch("loadOrganizations", {})
      await this.$store.dispatch("loadSensors", {});
      await this.$store.dispatch("loadOperations", {});
      await this.$store.dispatch("loadStations", {});
      await this.$store.dispatch("loadSensorStations", {});
      await this.$store.dispatch("loadQualities", {});
      await this.$store.dispatch("loadOperationSensorStation", {summary_operation});
      this.resultOfStationData = undefined;
      this.processedListStations = this.createListStationWithSensors(this.stations, this.sensors, this.sensorStations, this.operations, this.operationSensorStations);
    },

    createListStationWithSensors(stations, sensors, sensorStations, operations, operationSensorStations){
      const processedListStations = [];
      for (const station of stations) {
        const { codigo } = station;
        const listSensorStations = sensorStations.filter((sensorStation) => sensorStation.estacaoId === codigo);
        const sensorsFromSensorStationList = this.separateSensorsFromSensorStationList(station, listSensorStations, sensors, operations, operationSensorStations);
        processedListStations.push({ ...station, sensors:  sensorsFromSensorStationList});
      }
      return processedListStations;
    },

    separateSensorsFromSensorStationList(station, listSensorStations, sensors, operations, operationSensorStations){
      const separatedSensorsList = [];
      for (const sensorStation of listSensorStations) {
        const { sensorId } = sensorStation;
        const sensorFound = sensors.find((sensor) => sensor.codigo === sensorId);
        if(!sensorFound) continue;
        if (this.tab == 0) {
          const sensorOperation = this.findOperationOfSensorStation(station, sensorFound, operations, operationSensorStations);
          if(!sensorOperation) continue;
          const descritionOperation = sensorOperation ? ` | ${sensorOperation.descricao}` : "";
          const unitMeasureDescription = sensorFound.unidade_padrao ? ` (${sensorFound.unidade_padrao})` : "";
          separatedSensorsList.push({
            ...sensorFound,
            descricao: `${sensorFound.descricao}${unitMeasureDescription}${descritionOperation}`,
            name: `${sensorFound.descricao}${unitMeasureDescription}`,
            operation: sensorOperation
          });
        }
        else if (this.tab == 1) {
          const unitMeasureDescription = sensorFound.unidade_padrao ? ` (${sensorFound.unidade_padrao})` : "";
          separatedSensorsList.push({
            ...sensorFound,
            descricao: `${sensorFound.descricao}${unitMeasureDescription}`,
            name: `${sensorFound.descricao}${unitMeasureDescription}`,
            operation: null
          });
        }

      }
      return separatedSensorsList;
    },

    findOperationOfSensorStation(station, sensor, operations, operationSensorStations){
      const codigoSensor = sensor.codigo;
      const codigoStation= station.codigo;
      const operationSensorStationFound = operationSensorStations.find((operationSensorStation) => operationSensorStation.estacaoId === codigoStation && operationSensorStation.sensorId === codigoSensor );
      if(!operationSensorStationFound) return undefined;
      const { operacaoId } =  operationSensorStationFound;
      return operations.find((operation) => operation.codigo === operacaoId);
    },

    async changeDataType(dataType){
      let dataTypeValue = undefined;
      if(!this.isObservedData()){
        dataTypeValue = dataType.value;
      } else { dataTypeValue = 'observado' }
      await this.initialize(dataTypeValue);
    },

    isObservedData(){
      return this.tab === 1;
    },

    concatenateListIdsIntoString(list, keyName){
      return list.reduce((before, current)=>{
        const separateString = before ? "," : "";
        return `${before}${separateString}${current[keyName]}`;
      }, "");
    },

    stationFromProcessedStationList(station_ids, processedStationsList){
      return processedStationsList.find((station) => station.codigo == station_ids);
    },

    sensorsFromProcessedStationsList(station_ids, sensor_ids, processedStationsList){
      let ids = sensor_ids.split(',');
      let station = processedStationsList.find((a) => a.codigo === Number(station_ids));
      let sensors = []; //station.sensors
      for(let id in ids) {
        sensors.push(station.sensors.find((a) => a.codigo === Number(ids[id])));
      }
      return sensors;
    },

    async searchData(searchStationDataParams){
      this.loadingData = true;
      await this.searchStationData(searchStationDataParams);
      this.loadingData = false;
    },

    async searchStationData(searchStationDataParams){
      const { sensor_ids, operation_ids, station_ids, dataType } = searchStationDataParams;
      const { date_start, date_end, value } = dataType;
      const station = this.stationFromProcessedStationList(station_ids, this.processedListStations);
      const sensors = this.sensorsFromProcessedStationsList(station_ids, sensor_ids, this.processedListStations);
      if(this.isObservedData()){
        const loadParams = { station, sensor_ids, station_ids };
        const datetime_start = date_start;
        const datetime_end = date_end;
        const quality_ids = this.concatenateListIdsIntoString(this.qualities, "codigo");
        await this.$store.dispatch("loadReadingsData", { ...loadParams, quality_ids ,datetime_start, datetime_end });
        this.resultOfStationData = {...loadParams, resultList: this.readignsData, type: "observado", sensors: sensors, date_start: datetime_start, date_end: datetime_end };
      }
      else{
        const loadParams = { station, sensor_ids, operation_ids, station_ids };
        if(value === "horario") {
          const datetime_start = date_start;
          const datetime_end = date_end;
          await this.$store.dispatch("loadHourlySummary", { ...loadParams, datetime_start, datetime_end });
          this.resultOfStationData = {...loadParams, resultList: this.hourlySummary, type: "horario", sensors: sensors, date_start: datetime_start, date_end: datetime_end };
        }
        if(value === "diario"){
          await this.$store.dispatch("loadDailySummary", { ...loadParams, date_start, date_end });
          this.resultOfStationData = {...loadParams, resultList: this.dailySummary, type: "diario", sensors: sensors, date_start: date_start, date_end: date_end };
        }
        if(value === "mensal"){
          await this.$store.dispatch("loadMonthlySummary", { ...loadParams, date_start, date_end });
          this.resultOfStationData = {...loadParams, resultList: this.monthlySummary, type: "mensal", sensors: sensors, date_start: date_start, date_end: date_end };
        }
      }
    },

    async applyPeriod(periodSelected){
      const { period } = periodSelected;
      const [ date_start, date_end ] = period;
      const { sensor_ids, operation_ids, station_ids, type } = this.resultOfStationData;
      let dataType;
      if(type === "horario" || type === "observado"){
        dataType = { date_start: moment.tz( date_start, "America/Sao_Paulo").utc().format(), date_end:  moment.tz(date_end ,"America/Sao_Paulo").utc().format(), value: type };
      }
      else{
        dataType = { date_start, date_end, value: type };
      }

      this.loadingOtherPeriod = true;
      await this.searchStationData({ sensor_ids, operation_ids, station_ids, dataType });
      this.loadingOtherPeriod = false;
    }
  }
}
</script>

<style scoped>
.title-page{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page{
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}

.v-tab{
  text-transform: none;
}
</style>
